import {
  loadFixture, paginate, findById, parseBody, parseQuery, mergeEntity, urlParam,
} from '../mockDataStore';

const USER_DETAIL = /^\/?api\/v1\/users\/(\d+)\/?$/;

function applySearch(list, search, fields) {
  if (!search) return list;
  const needle = search.toLowerCase();
  return list.filter((item) => fields.some((field) => (
    String(item[field] || '').toLowerCase().includes(needle)
  )));
}

export default function registerSuperAdminMocks(mock) {
  mock.onGet(/^\/?api\/v1\/users(\?.*)?$/).reply(async (config) => {
    const users = await loadFixture('super-admin/users');
    const query = parseQuery(config.url);
    const filtered = applySearch(users.results, query.search, ['first_name', 'last_name', 'email']);
    return [200, paginate(filtered, query)];
  });

  mock.onGet(USER_DETAIL).reply(async (config) => {
    const users = await loadFixture('super-admin/users');
    const user = findById(users.results, Number(urlParam(config, USER_DETAIL)));
    return user ? [200, user] : [404, { message: 'Not found.' }];
  });

  mock.onPatch(USER_DETAIL).reply(async (config) => {
    const users = await loadFixture('super-admin/users');
    const user = findById(users.results, Number(urlParam(config, USER_DETAIL)));
    if (!user) return [404, { message: 'Not found.' }];
    mergeEntity(user, parseBody(config), ['profile_picture']);
    return [200, user];
  });

  mock.onDelete(USER_DETAIL).reply(async (config) => {
    const users = await loadFixture('super-admin/users');
    const userId = Number(urlParam(config, USER_DETAIL));
    users.results = users.results.filter((user) => user.id !== userId);
    users.count = users.results.length;
    return [200, {}];
  });

  mock.onGet(/^\/?api\/v1\/groups\/\?.*search_admin=true/).reply(async (config) => {
    const groups = await loadFixture('super-admin/groups');
    const query = parseQuery(config.url);
    let filtered = applySearch(groups.results, query.search, ['name', 'slug']);
    if (query.is_deactivated === '0') {
      filtered = filtered.filter((group) => !group.is_deactivated);
    }
    return [200, paginate(filtered, query)];
  });

  mock.onGet(/^\/?api\/v1\/groups\/[\w-]+\/users\/?(\?.*)?$/).reply(async (config) => {
    const profiles = await loadFixture('groups/profiles');
    const query = parseQuery(config.url);
    const filtered = applySearch(profiles.results, query.search, ['first_name', 'last_name', 'email']);
    return [200, paginate(filtered, query)];
  });
}
